import { Spinner } from "@adfenix/alexandria";
import { useQuery } from "@tanstack/react-query";
import { PropertyServiceApi } from "api/services";
import { useQueryString } from "hooks";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

interface Props {}
export const LegacyResult = ({}: Props) => {
  const { guid } = useQueryString();
  const navigate = useNavigate();
  const {
    property: { authV2PropertyDetail }
  } = PropertyServiceApi;
  const { data } = useQuery(
    ["getPropertyById", guid],
    () => authV2PropertyDetail(guid!),
    {
      enabled: !!guid
    }
  );

  useEffect(() => {
    if (data?.hqId && guid) {
      navigate(`/customer/hq/${data.hqId}/property/results/${guid}`);
    }
  }, [data, guid, navigate]);

  return <Spinner centered />;
};
